import { useLanguage } from '@/lib/i18n/LanguageContext';
import { LocalizedLink } from '@/components/LocalizedLink';
import { OPEN_COOKIE_SETTINGS_EVENT } from './CookieConsent';
import logoAsset from '../../../public/images/logo.webp.asset.json';
const logo = logoAsset.url;

export function Footer() {
  const { t } = useLanguage();

  const handleOpenCookieSettings = () => {
    window.dispatchEvent(new CustomEvent(OPEN_COOKIE_SETTINGS_EVENT));
  };

  return (
    <footer className="border-t bg-muted/30">
      <div className="container py-12 md:py-16">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
          {/* Product */}
          <div>
            <h3 className="font-semibold mb-4">{t('footer.product')}</h3>
            <ul className="space-y-1 text-sm text-muted-foreground">
              <li><LocalizedLink routeKey="productPms" className="hover:text-foreground transition-colors inline-block py-1.5">{t('nav.pms')}</LocalizedLink></li>
              <li><LocalizedLink routeKey="productChannelManager" className="hover:text-foreground transition-colors inline-block py-1.5">{t('nav.channelManager')}</LocalizedLink></li>
              <li><LocalizedLink routeKey="productWebsiteBuilder" className="hover:text-foreground transition-colors inline-block py-1.5">{t('nav.websiteBuilder')}</LocalizedLink></li>
              <li><LocalizedLink routeKey="features" className="hover:text-foreground transition-colors inline-block py-1.5">{t('nav.features')}</LocalizedLink></li>
              <li><LocalizedLink routeKey="integrations" className="hover:text-foreground transition-colors inline-block py-1.5">{t('nav.integrations')}</LocalizedLink></li>
            </ul>
          </div>

          {/* Company */}
          <div>
            <h3 className="font-semibold mb-4">{t('footer.company')}</h3>
            <ul className="space-y-1 text-sm text-muted-foreground">
              <li><LocalizedLink routeKey="about" className="hover:text-foreground transition-colors inline-block py-1.5">{t('nav.about')}</LocalizedLink></li>
              <li><LocalizedLink routeKey="blog" className="hover:text-foreground transition-colors inline-block py-1.5">{t('nav.resources')}</LocalizedLink></li>
              <li><LocalizedLink routeKey="briefDescription" className="hover:text-foreground transition-colors inline-block py-1.5">{t('nav.briefDescription')}</LocalizedLink></li>
              <li><LocalizedLink routeKey="testimonials" className="hover:text-foreground transition-colors inline-block py-1.5">{t('nav.testimonials')}</LocalizedLink></li>
              <li><LocalizedLink routeKey="pricing" className="hover:text-foreground transition-colors inline-block py-1.5">{t('nav.pricing')}</LocalizedLink></li>
            </ul>
          </div>

          {/* Support */}
          <div>
            <h3 className="font-semibold mb-4">{t('footer.support')}</h3>
            <ul className="space-y-1 text-sm text-muted-foreground">
              <li><LocalizedLink routeKey="faq" className="hover:text-foreground transition-colors inline-block py-1.5">FAQ</LocalizedLink></li>
              <li><LocalizedLink routeKey="contact" className="hover:text-foreground transition-colors inline-block py-1.5">{t('nav.contact')}</LocalizedLink></li>
              <li><a href="https://www.rentalbookingsystem.com" target="_blank" rel="noopener noreferrer nofollow" className="hover:text-foreground transition-colors inline-block py-1.5">{t('nav.loginTooltip')}</a></li>
              <li><a href="mailto:info@i-rent.net" className="hover:text-foreground transition-colors inline-block py-1.5">{t('contact.info.email')}</a></li>
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h3 className="font-semibold mb-4">{t('footer.legal')}</h3>
            <ul className="space-y-1 text-sm text-muted-foreground">
              <li><LocalizedLink routeKey="privacy" className="hover:text-foreground transition-colors inline-block py-1.5">{t('footer.privacy')}</LocalizedLink></li>
              <li><LocalizedLink routeKey="terms" className="hover:text-foreground transition-colors inline-block py-1.5">{t('footer.terms')}</LocalizedLink></li>
              <li><LocalizedLink routeKey="publicationTerms" className="hover:text-foreground transition-colors inline-block py-1.5">{t('footer.publicationTerms')}</LocalizedLink></li>
              <li><LocalizedLink routeKey="websiteTerms" className="hover:text-foreground transition-colors inline-block py-1.5">{t('footer.websiteTerms')}</LocalizedLink></li>
              <li>
                <button 
                  onClick={handleOpenCookieSettings}
                  className="hover:text-foreground transition-colors text-left inline-block py-1.5"
                >
                  {t('footer.cookieSettings')}
                </button>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t flex flex-col md:flex-row justify-between items-center gap-4">
          <div className="flex items-center gap-3">
            <img src={logo} alt="i-Rent.net" className="h-6 w-auto" width={73} height={24} loading="lazy" decoding="async" />
            <span className="text-sm text-muted-foreground">— {t('footer.tagline')}</span>
          </div>
          <p className="text-sm text-muted-foreground">{t('footer.copyright')}</p>
        </div>
      </div>
    </footer>
  );
}
